import { render } from "./CourseItem.vue?vue&type=template&id=f91df598&scoped=true"
import script from "./CourseItem.vue?vue&type=script&lang=js"
export * from "./CourseItem.vue?vue&type=script&lang=js"

import "./CourseItem.vue?vue&type=style&index=0&id=f91df598&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f91df598"]])

export default __exports__